/**
 * 用户操作同步拦截器标识符
 */
export const USER_OPERATION_SYNC_INTERCEPTOR_IDENTIFIER = 'UserOperationSyncInterceptor';
/**
 * 当前执行操作的上下文源
 */
export const SYNC_CONTEXT_SOURCE = 'SyncContextSource';

/**
 * 动作来源
 */
export const ACTION_SOURCE = {
  REMOTE: 'remote',
  LOCAL: 'local'
};
/**
 * 当前执行操作主体
 */
export const CONTEXT_SOURCE = {
  NONE: 'none',
  REMOTE: 'remote',
  LOCAL: 'local'
};

/**
 * 用户类型
 */
export const USER_TYPE = {
  NONE: 'none',
  USER: 'user',
  SALES: 'sales'
};